<template>
  <v-card-text>
    <!-- Page Header -->
    <v-card class="custom-card px-4 py-2 mb-2">
      <v-row density="compact">
        <v-col cols="12" sm="6" md="6">
          <v-chip-group
            v-model="filterStatus"
            selected-class="bg-primary text-white border-primary"
            mandatory
          >
            <v-chip
              v-for="status in statusFilters"
              :key="status.value"
              :value="status.value"
              variant="outlined"
              color="white"
              class="font-weight-bold px-4"
            >
              {{ status.title }}
            </v-chip>
          </v-chip-group>
        </v-col>
        <v-col cols="12" sm="6" md="6" class="d-flex justify-end">
          <!-- <v-select
            variant="outlined"
            density="compact"
            color="primary"
            max-width="280"
            :items="[
              {
                title: 'Pending',
                value: 'PENDING',
              },
              {
                title: 'Approved',
                value: 'APPROVED',
              },
              {
                title: 'Rejected',
                value: 'REJECTED',
              },
            ]"
            v-model="filterStatus"
            hide-details
            label="Filter By Status"
          ></v-select> -->
        </v-col>
      </v-row>
    </v-card>

    <div>
      <v-card class="custom-card">
        <v-data-table
          :headers="headers"
          :items="GetAllPollRequestsList"
          :itemsPerPage="itemsPerPage"
          :height="vuetifyObject?.height - 205"
          v-model:page="page"
          class="elevation-0"
          density="compact"
          hide-default-footer
          :loading="loading"
          :items-per-page="10"
          @click:row="ViewPollRequest"
        >
          <template v-slot:[`item.title`]="{ item }">
            <div class="font-weight-600">{{ item.title }}</div>
          </template>

          <template v-slot:[`item.workflow_status`]="{ item }">
            <v-chip
              :color="
                item.workflow_status === 'PENDING'
                  ? 'warning'
                  : item.workflow_status === 'APPROVED'
                  ? 'success'
                  : 'error'
              "
              size="small"
              class="font-weight-bold"
            >
              {{ item.workflow_status }}
            </v-chip>
          </template>

          <template v-slot:[`item.created_on`]="{ item }">
            {{ formatDate(item.created_on) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex gap-2">
              <v-menu v-if="item.workflow_status == 'PENDING'">
                <template v-slot:activator="{ props }">
                  <v-btn
                    size="small"
                    variant="text"
                    icon="mdi-dots-vertical"
                    v-bind="props"
                  ></v-btn>
                </template>
                <v-list density="compact" class="text-subtitle">
                  <v-list-item
                    title="Approve/Reject"
                    @click="ViewPollRequest(false, { item })"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        size="small"
                        color="warning"
                        icon="mdi-shield-check"
                      ></v-icon>
                    </template>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-icon v-else color="primary">mdi-eye</v-icon>
            </div>
          </template>
        </v-data-table>
        <v-pagination
          density="compact"
          :length="pageCount"
          v-model="page"
        ></v-pagination>
      </v-card>
      <ViewPollRequestDialog
        v-model:dialog="showDialog"
        :internalPincodes="internalPincodes"
        :request="selectedPoll"
        @clicked="ViewPollRequestDialogEmit"
      />
    </div>
  </v-card-text>
</template>

<script>
import { ListAllWorkflows } from "@/mixins/Extras/ListAllWorkflows";
import ViewPollRequestDialog from "@/components/RequestPolls/Dialogs/ViewPollRequestDialog.vue";

export default {
  name: "RequestToPollPage",
  components: {
    ViewPollRequestDialog,
  },
  props: {
    vuetifyObject: {
      type: Object,
      required: false,
    },
    internalPincodes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  mixins: [ListAllWorkflows],
  data() {
    return {
      itemsPerPage: 100,
      page: 1,
      searchQuery: "",
      selectedSort: "newest",
      filterStatus: "PENDING",
      statusFilters: [
        {
          title: "Pending",
          value: "PENDING",
        },
        {
          title: "Approved",
          value: "APPROVED",
        },
        {
          title: "Rejected",
          value: "REJECTED",
        },
      ],
      loading: false,
      showDialog: false,
      selectedPoll: {},
      headers: [
        { title: "Poll Title", key: "title", width: "50%" },
        { title: "Status", key: "workflow_status", width: "15%" },
        { title: "Requested on", key: "created_on", width: "20%" },
        { title: "Actions", key: "actions", sortable: false, width: "15%" },
      ],
      GetAllPollRequestsList: [],
    };
  },
  async mounted() {
    this.GetAllPollRequestsList = await this.GetAllWorkflowsMethod(
      this.filterStatus,
      "POLL_CREATION_REQUEST",
    );
  },
  computed: {
    pageCount() {
      return Math.ceil(this.GetAllPollRequestsList?.length / this.itemsPerPage);
    },
  },
  watch: {
    async filterStatus(newStatus) {
      this.GetAllPollRequestsList = await this.GetAllWorkflowsMethod(
        newStatus,
        "POLL_CREATION_REQUEST",
      );
    },
  },
  methods: {
    formatDate(epoch) {
      if (!epoch) return "N/A";
      const date = new Date(epoch);
      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    ViewPollRequest(row, data) {
      this.selectedPoll = data.item;
      this.showDialog = true;
    },
    async ViewPollRequestDialogEmit(Toggle) {
      this.showDialog = false;
      if (Toggle == 2) {
        this.GetAllPollRequestsList = await this.GetAllWorkflowsMethod(
          this.filterStatus,
          "POLL_CREATION_REQUEST",
        );
      }
    },
  },
};
</script>
<style></style>
